import makeStyles from '@material-ui/core/styles/makeStyles';
import { Trans } from '@lingui/macro';
import { Typography } from '@material-ui/core';
import clsx from 'clsx';

import Result from './Result';
import { useHighlightingStyles } from './UseHighlightingStyles';
import { useStore } from './UseGlobalSearchStore';
import { DOUBLE_ROW_HEIGHT, ROW_HEIGHT, TWELVE_ROW_HEIGHT } from './Constants';

const useStyles = makeStyles((theme) => ({
    root: {},

    resultList: {
        overflowY: 'auto',
        overflowX: 'hidden',
        maxHeight: `min(${TWELVE_ROW_HEIGHT}px, calc(100vh - ${DOUBLE_ROW_HEIGHT}px))`,
    },

    statusText: {
        padding: theme.spacing(2),
    },

    statusRow: {
        padding: theme.spacing(0, 2),
        height: ROW_HEIGHT,
        lineHeight: `${ROW_HEIGHT}px`,
        cursor: 'default',
    },
}));

export default function ResultList() {
    const classes = useStyles();
    const { annotatedText } = useHighlightingStyles();

    const { rows, totalMatches, isLoading, exactMatches, error } = useStore();

    if (error) {
        return (
            <Typography component="div" className={classes.statusText} variant="subtitle2">
                <Trans>An error occurred attempting your search! Please try again later.</Trans>
            </Typography>
        );
    }

    return (
        <div className={classes.root}>
            {totalMatches > 0 ? (
                <>
                    <div className={classes.resultList}>
                        {rows.map((row) => (
                            <div key={row.id}>
                                <Result result={row} />
                            </div>
                        ))}
                    </div>

                    <div className={clsx(classes.statusRow, annotatedText)}>
                        {exactMatches ? (
                            <span>
                                Found and <em>highlighted</em>{' '}
                                <Typography component="span" variant="subtitle2">
                                    {totalMatches}
                                </Typography>{' '}
                                exact {totalMatches > 1 ? 'matches' : 'match'}
                            </span>
                        ) : (
                            <span>
                                Found and <fuzzy>highlighted</fuzzy>{' '}
                                <Typography component="span" variant="subtitle2">
                                    {totalMatches}
                                </Typography>{' '}
                                close {totalMatches > 1 ? 'matches' : 'match'}
                            </span>
                        )}
                    </div>
                </>
            ) : (
                <Typography variant="subtitle2" className={clsx(classes.statusText, annotatedText)}>
                    {isLoading ? <Trans>Loading...</Trans> : <Trans>No Results</Trans>}
                </Typography>
            )}
        </div>
    );
}
